import { render, staticRenderFns } from "./CreateAccessories.vue?vue&type=template&id=19ee768c&"
import script from "./CreateAccessories.vue?vue&type=script&lang=js&"
export * from "./CreateAccessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports